import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IConversationOrderData } from '../../types/conversations/IConversation';

interface ConversationOrderState {
  data?: IConversationOrderData;
}

const initialState = { data: undefined } as ConversationOrderState;

export const conversationOrderSlice = createSlice({
  name: 'conversationOrder',
  initialState,
  reducers: {
    setConversationOrder(state, action: PayloadAction<IConversationOrderData | undefined>) {
      state.data = action.payload;
    },
  },
});

export const { setConversationOrder } = conversationOrderSlice.actions;
